import { FilterType } from '@/types/analytics/analytics.types';
import { DxFilter } from '@/types/analytics/data-explorer.types';
import { createFilterString } from '@middleware/common';
import { getFilterIdentifier } from '@/reports/funnel/funnel-aggregator-builder/funnel-aggregator-builder';

export interface PathFilter extends DxFilter {
    group?: string;
}

interface PathFilterConfig {
    bulkExpand: string[];
    filterString?: string;
    hasDevicePropFilter: boolean;
    hasRegionFilter: boolean;
}

export default function generatePathFilters (filters?: PathFilter[], similarityScore?: number): PathFilterConfig {
    const hasFilters = (filters && filters.length > 0) || similarityScore;
    const bulkExpand: string[] = [];
    let filterString: string | undefined = hasFilters ? '' : undefined;
    let hasDevicePropFilter = false;
    let hasRegionFilter = false;

    if (filters && filters.length > 0) {
        filters.forEach((filter: PathFilter, filterIdx: number) => {
            filterString += `(${createFilterString(filter, getFilterIdentifier)})`;

            if (filterIdx !== filters.length - 1 || similarityScore) {
                filterString += '&&';
            }

            if (filter.filterType === FilterType.Device) {
                hasDevicePropFilter = true;
            }
            if (filter.filterType === FilterType.Location && filter.field === 'region') {
                hasRegionFilter = true;
            }

            if (filter.filterType === FilterType.Visitor && filter.field !== 'id') {
                bulkExpand.push(filter.filterType);
            }

            if (filter.filterType === FilterType.Account && filter.field !== 'id') {
                bulkExpand.push(filter.filterType);
            }

            if (filter.filterType === FilterType.ParentAccount) {
                bulkExpand.push(filter.filterType);
            }
        });
    }
    if (similarityScore) {
        filterString += `(similarityScore > ${similarityScore})`;
    }

    return {
        bulkExpand,
        filterString,
        hasDevicePropFilter,
        hasRegionFilter,
    };
}
